import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20m.41-36.833L24.55 24.5l10.337 3.75zm-.937.667L5 28.917l16.53-14.478zM34.97 29.208l-20.46-7.416-8.498 7.416z",
    fillRule: "evenodd",
    fill: "currentColor"
  }
) });
export {
  s as G
};
